import { Card } from '@components/card';
import { FileButton } from '@components/file-button';
import { FormInstance } from '@components/form/create-form';
import { ImageViewer } from '@components/previewer';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { SocialData } from 'api/jobs/requests';

import { SettingsTitle } from './common';

import { SettingsLocale, SocialFormValues } from '../settings';

type SocialSettingsProps = {
  form: FormInstance<SocialFormValues>;
  initialData: SocialData;

  sharingImage: File | null;
  setSharingImage: (file: File | null) => void;
};

export const SocialSettings = ({
  form: Form,
  initialData,
  sharingImage,
  setSharingImage,
}: SocialSettingsProps) => {
  const { t } = useScopedTranslate(SettingsLocale);
  const imageUrl = sharingImage ? URL.createObjectURL(sharingImage) : initialData.image;

  return (
    <>
      <Card variant="transparent" space={6}>
        <Stack space={4}>
          <SettingsTitle title={t('socialImage')} description={t('settingsDescription')} />
          <Stack orientation="vertical" space={6}>
            <ImageViewer url={imageUrl} maxWidth={1200} />
            <Stack space={4} align="flex-end">
              <FileButton
                key={sharingImage?.name}
                isReplace
                replaceText={t('replaceText')}
                onFileSelected={setSharingImage}
                fileType="image"
              />
              <Text font="regular14" color="purple60" text={t('acceptedFileTypes')} />
            </Stack>
          </Stack>
        </Stack>
      </Card>
      <Card variant="transparent" space={6}>
        <Stack space={4}>
          <SettingsTitle
            title={t('socialSharingDetails')}
            description={t('socialSharingDetailsDescription')}
          />
          <Form.TextField
            id="sharingTitle"
            defaultValue={initialData.title ?? ''}
            label={t('sharingTitle')}
            dataCy="sharing-title"
          />
          <Form.Textarea
            id="sharingDescription"
            label={t('sharingDescription')}
            dataCy="sharing-description"
            defaultValue={initialData.description ?? ''}
          />
        </Stack>
      </Card>
    </>
  );
};
